import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/primeng';
import { SelectItem,MenuItem } from 'primeng/primeng';
import { AlarmService } from '../services/alarm.service';
import { AlarmTypeService } from '../services/alarm-type.service';
import { UserService } from '../services/user.service';
import { DeviceService } from '../services/device.service';
import { GeofenceService } from '../services/geofence.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-alarm',
  templateUrl: './alarm.component.html',
  styleUrls: ['./alarm.component.css']
})
export class AlarmComponent implements OnInit {

  steps :MenuItem[];
  emails: string[];
  activeIndex: number = 1;
  msgs: Message[] = [];
  alarm: any={};
  alarms : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  displayDevices: boolean = false;
  alarmTypes: SelectItem[];
  geofences:SelectItem[];
  blockedDocument: boolean = false;
  devicesAvailables: any[]=[];
  devicesSelecteds : any[]=[];
  status: SelectItem[];
  statusFilter: SelectItem[];
  emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  constructor(private alarmService : AlarmService,private userService: UserService
    ,private confirmationService: ConfirmationService,private deviceService:DeviceService
    ,private alarmTypeService : AlarmTypeService,private geofenceService:GeofenceService) { }

  ngOnInit() {
    this.statusFilter = [
            {label: 'Todos', value: null },
            {label: 'Habilitado', value: 'H'},
            {label: 'Inhabilitado', value: 'I'}
        ];
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
    this.alarmTypes = [];
    this.alarmTypeService.findByStatus("H").then(data => {
      let response: any = data;
      response.alarmTypes.forEach(item => {
        this.alarmTypes.push({label: item.description, value: item.idAlarmType});
      });
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.activeIndex = 0;
    this.steps = [{
      label: 'Registrar Alarma',
      command: (event: any) => {
        this.activeIndex = 0;
      }
    },
    {
      label: 'Asignar Equipo',
      command: (event: any) => {
        this.activeIndex = 1;
      }
    }];

    this.geofences=[];
    this.geofenceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.geofences.forEach(item => {
        this.geofences.push({label: item.name, value: item.idGeofence});
      });
      this.init();
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
  }

  init(){
    this.emails=[];
    this.activeIndex = 0;
    this.devicesAvailables = [];
    this.devicesSelecteds = [];
    this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devicesAvailables.push(item);
      });
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.blockedDocument=true;
    this.alarms = [];
    this.alarmService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.alarms.forEach(item => {
        if(item.idAlarmType.indexOf("geofence") >= 0){
          let geofence = this.geofences.find(geofence => geofence.value == item.idGeofence);
          if(geofence){
            item.parameter = item.idGeofence + " - "+geofence.label;
          }
        }else if(item.idAlarmType.indexOf("speed") >= 0){
          item.parameter = item.limitValue;
        }
        this.alarms.push(item);
      });
      this.blockedDocument=false;
    }).catch(err =>{
      this.blockedDocument=false;
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });
    this.alarm = {status:"H",limitValue:80,idUser:this.userService.userLoged.idUser};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayDevices = false;
  }

  isDevicesSelected(){
    return this.devicesSelecteds.length > 0;
  }

  nextStep(){
    if(this.validateEmails()){
      this.activeIndex++;
    }else{
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Formato de email no válido"}];
    }
  }

  prevStep(){
    this.activeIndex--;
  }

  showAdd(){
    this.init();
    this.displayAdd = true;
  }

  showEdit(alarm:any){
    this.alarm=alarm;
    if(this.alarm.email == null || this.alarm.email == ""){
      this.emails = [];
    }else{
      this.emails = this.alarm.email.split(";");
    }
    this.displayEdit = true;
  }

  showDevices(alarm:any){
    this.alarm=alarm;
    this.emails = this.alarm.email.split(";");
    this.displayDevices = true;

    this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      this.devicesAvailables = [];
      this.devicesSelecteds = [];
      response.devices.forEach(device => {
          let isSelected = false;
          alarm.devices.forEach(alarmDevice => {
            if(device.idDevice == alarmDevice.idDevice){
              this.devicesSelecteds.push(device);
              isSelected = true;
            }
          });
          if(!isSelected){
            this.devicesAvailables.push(device);
          }
      });



      /*alarm.devices.forEach(item => {
        if(this.devicesAvailables.some(deviceAvailable => deviceAvailable.idDevice === item.idDevice)){
          this.devicesSelecteds.push(item);
        }

        let indice = -1;
        //let i = 0;
        this.devicesAvailables.forEach((available,i) => {
          if(item.idDevice == available.idDevice){
            indice = i;
          }
          //i++;
        });
        if(indice> -1){
          this.devicesAvailables.splice(indice,1);
        }
      });*/
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

  }

  hide(){
    this.activeIndex = 0;
    this.emails=[];
    this.alarm = {status:"H",limitValue:80};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayDevices = false;
    this.init();
  }

  add(){

    this.blockedDocument = true;

    this.alarm.devices = [];
    this.devicesSelecteds.forEach(item => {
      this.alarm.devices.push(item);
    });

    this.alarm.email ="";
    this.emails.forEach(item => {
      this.alarm.email += item + ";"
    });
    this.alarm.email =  this.alarm.email.substring(0,this.alarm.email.length-1)
    this.alarmService.create(this.alarm).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      this.blockedDocument = false;
    });
  }

  validateEmails():boolean{
    let emailsValidos = true;
    this.emails.forEach(item => {
      if(item != null && item != "" && !this.emailRegex.test(item)){
        emailsValidos = false;
      }
    });
    if(!emailsValidos){
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Formato de email no válido"}];
      return false;
    }
    return true;
  }

  edit(){
    if(!this.validateEmails()){
      return;
    }
    this.blockedDocument = true;

    if(this.devicesSelecteds != null || this.devicesSelecteds.length > 0){
      this.alarm.devices = [];
      this.devicesSelecteds.forEach(item => {
        this.alarm.devices.push(item);
      });
    }

    this.alarm.email ="";
    this.emails.forEach(item => {
      this.alarm.email += item + ";"
    });
    this.alarm.email =  this.alarm.email.substring(0,this.alarm.email.length-1)
    this.alarmService.edit(this.alarm).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.alarmService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }

  onChange(event){
    if(event.value== "overspeed"){
      this.alarm.limitValue=80;
    }else if(event.value== "leisure"){
      this.alarm.limitValue=20;
    }else if(event.value== "parking"){
      this.alarm.limitValue=20;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/alarm/alarm.component.ts